import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70bb5ce7")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BAGIcon = _resolveComponent("BAGIcon")!

  return (_openBlock(), _createBlock("div", {
    class: ["p-2", {
      'flex items-center justify-center': _ctx.centerCombinedIllustration,
      'duplicate-scan-illustration flex-col items-center': _ctx.isDuplicateScan
    }],
    style: _ctx.centerCombinedIllustration ? { minHeight: '211px' } : {}
  }, [
    (_ctx.isSTT)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.decideSTTIconComponent), {
          key: 0,
          flag: _ctx.flag,
          "region-name": _ctx.regionName,
          "is-sti-dest": _ctx.isStiDest,
          "is-underpaid": _ctx.isUnderpaid
        }, null, 8, ["flag", "region-name", "is-sti-dest", "is-underpaid"]))
      : (_openBlock(), _createBlock(_component_BAGIcon, {
          key: 1,
          "region-name": _ctx.regionName,
          "is-sti-dest": _ctx.isStiDest
        }, null, 8, ["region-name", "is-sti-dest"])),
    (_ctx.isDuplicateScan)
      ? (_openBlock(), _createBlock("img", {
          key: 2,
          src: !_ctx.isForeignAccount ? require('@/app/ui/assets/svg/sti-reverse-scan/duplicate-scan-label.svg') : require('@/app/ui/assets/svg/sti-reverse-scan/duplicate-scan-label-en.svg'),
          alt: _ctx.$t('STT Sudah Di Scan'),
          width: "280",
          height: "45",
          class: "mx-auto mt-2",
          style: {"max-width":"100%","height":"auto"}
        }, null, 8, ["src", "alt"]))
      : _createCommentVNode("", true)
  ], 6))
})